import { render } from "./CreditTicket.vue?vue&type=template&id=40bbe48a&scoped=true&ts=true"
import script from "./CreditTicket.vue?vue&type=script&lang=ts"
export * from "./CreditTicket.vue?vue&type=script&lang=ts"

import "./CreditTicket.vue?vue&type=style&index=0&id=40bbe48a&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bbe48a"]])

export default __exports__